export default "__VITE_ASSET__3a67a293__"